import { useTranslation } from 'react-i18next'
import { TextLink } from '@/components/TextLink/TextLink'
import { useRoutingLocale } from '@/utils/l10n/useRoutingLocale'
import { PageLink } from '@/utils/PageLink'
import { sprinkles } from 'ui/src/theme/sprinkles.css'

// Lunk to privacy policy shown where we collect SSN data
export function GdprBeforeOfferPrivacyLink() {
  const { t } = useTranslation('purchase-form')
  const locale = useRoutingLocale()

  return (
    <TextLink
      className={sprinkles({ textAlign: 'center' })}
      href={PageLink.privacyPolicy({ locale })}
      color="textSecondary"
      target="_blank"
      size="xs"
    >
      {t('GDPR_LINK_BEFORE_OFFER')}
    </TextLink>
  )
}
